import React, { useState } from "react";

const CollapsibleSection = ({ title, children, defaultOpen = false, headerRight }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="shadow-lg overflow-hidden">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between px-4 py-3 bg-slate-800 text-slate-200 font-semibold text-sm uppercase tracking-wider hover:bg-slate-700 transition-colors"
      >
        <span>{title}</span>
        <span className="flex items-center gap-2">
          {headerRight && (
            <span onClick={(e) => e.stopPropagation()}>{headerRight}</span>
          )}
        <svg
          className={`w-5 h-5 text-slate-400 transition-transform duration-200 ${
            isOpen ? "rotate-180" : ""
          }`}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
        </span>
      </button>
      {isOpen && <div className="pt-3">{children}</div>}
    </div>
  );
};

export default CollapsibleSection;
